import React from "react";
import "./New.scss";
import Comingsoon from "../../Media/Winnie (1).webp";
import Soon from "../../Media/Winnie (2).webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6287876666122&text=Halo%20Anggi,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Wisata%20(N1%20at%20Arcovia)%20https://perumahan-grand-wisata.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="flashsale" className="container-soon">
      <div className="louise">
        <h1>New Launching Grand Wisata</h1>
        <h2> Cluster N1 at Arcova</h2>
      </div>
      <div className="maps-lokasi">
        <img
          id="location"
          className="img-lokasi-dekstop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
